export default {
	getById(id, cb, ecb = null) {
		this.http
			.get(`/report/${id}`)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},

	search(params, cb, ecb) {
		this.http
			.get('/report', {
				params
			})
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	update(form, cb, ecb) {
		this.http
			.post('/report', form)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	status(id, to, cb, ecb) {
		this.http
			.get(`/report/${id}/status/${to}`, {})
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	generateOLD(id, params, cb, ecb) {
		this.http
			.get(`/report/generate/${id}`, {
				params
			})
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	generate(id, params, cb, ecb) {
		this.http
			.get(`/report/${id}/generate`, {
				params
			})
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	sql(id, params, cb, ecb) {
		this.http
			.get(`/report/${id}/sql`, params)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	getChartById(id, cb, ecb = null) {
		this.http
			.get(`/report/chart/${id}`)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	getChartDataOLD(id, params, cb, ecb) {
		this.http
			.get(`/report/getChartData/${id}`, {
				params
			})
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	getChartData(id, params, cb, ecb) {
		this.http
			.get(`/report/chart/${id}`, {
				params
			})
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	searchChart(params, cb, ecb) {
		this.http
			.get('/report/chart', {
				params
			})
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	updateChart(form, cb, ecb) {
		this.http
			.post('/report/chart', form)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	removeChart(id, cb, ecb) {
		this.http
			.delete(`/report/chart/${id}`)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	searchParameter(params, cb, ecb) {
		this.http
			.get(`/report/parameter`, {
				params
			})
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	getParameters(reportid, cb, ecb) {
		this.http
			.get(`/report/${reportid}/parameters`)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	removeParameter(id, cb, ecb) {
		this.http
			.delete(`/report/parameter/${id}`)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	updateParameter(form, cb, ecb) {
		this.http
			.post(`/report/parameter`, form)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	searchColumn(params, cb, ecb) {
		this.http
			.get(`/report/column`, {
				params
			})
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	getColumns(reportid, cb, ecb) {
		this.http
			.get(`/report/${reportid}/columns`)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	removeColumn(id, cb, ecb) {
		this.http
			.delete(`/report/column/${id}`)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	},
	updateColumn(form, cb, ecb) {
		this.http
			.post(`/report/column`, form)
			.then((response) => cb && cb(response))
			.catch((e) => ecb && ecb(e))
	}
}
